<template>
  <div>
    <v-alert :value="true" type="info"
      >Search using the filter boxes at the top of the columns. Sort by clicking
      the column name. Click a button to go to the record.</v-alert
    >
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2><v-icon>search</v-icon>Filter Records</h2>
        </template>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.id" label="Id" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.fileid"
                    label="File id"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.freereference"
                    label="Free reference"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.sender"
                    label="Sender"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.senderreference"
                    label="Sender reference"
                    outline
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn @click="searchFilters" :loading="loading">
              <v-icon>search</v-icon>
              <span>&#160;Search</span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="receiptsCount"
      :loading="loading"
      :headers="computedHeaders"
      :items="receipts"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{ name: 'receipt', params: { id: props.item.id } }"
              small
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.sender }}</td>
          <td>{{ props.item.senderreference }}</td>
          <td>{{ props.item.bacs }}</td>
          <td style="text-align: right">
            {{ props.item.amount | toCurrency }}
          </td>
          <td>{{ props.item.timestamp | formatDateTime }}</td>
          <td v-if="isSelecting">
            <v-btn @click="$emit('claimReceipt', props.item.id)">Claim</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ReceiptsUnclaimed",
  props: ["isSelecting"],
  computed: {
    firstRow() {
      const { page, rowsPerPage } = this.pagination;
      return (page - 1) * rowsPerPage;
    },
    computedHeaders() {
      const headers = [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Sender",
          value: "sender",
        },
        {
          text: "Reference",
          value: "senderreference",
        },
        {
          text: "Bacs",
          value: "bacs",
        },
        {
          text: "Amount",
          value: "amount",
          align: "right",
        },
        {
          text: "Date",
          value: "timestamp",
        },
      ];
      if (this.isSelecting) {
        headers.push({
          text: "",
          sortable: false,
        });
      }
      return headers;
    },
  },
  data() {
    return {
      receiptsCount: 0,
      receipts: [],
      filters: {
        id: null,
        fileid: null,
        freereference: null,
        sender: null,
        senderreference: null,
      },
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "timestamp",
        descending: true,
      },
      showFirstLastPage: true,
      showCurrentPage: true,
      panel: [],
    };
  },
  methods: {
    fetchReceipts(rowsPerPage) {
      nbmlaw
        .post(
          `/cors/admin/fundview/receipts/search/unclaimed/${this.firstRow}/${rowsPerPage}`,
          this.filters
        )
        .then((response) => {
          // console.log(response.data);
          this.receipts = response.data;
          this.loading = false;
        });
    },
    fetchReceiptsCount() {
      nbmlaw
        .post(
          `/cors/admin/fundview/receipts/search/unclaimed/count`,
          this.filters
        )
        .then((response) => {
          // console.log(response.data)
          this.receiptsCount = response.data;
        });
    },
    update() {
      this.loading = true;
      const { sortBy, descending, rowsPerPage } = this.pagination;
      if (rowsPerPage != -1) {
        this.filters.sortBy = sortBy;
        this.filters.descending = descending;
        this.fetchReceiptsCount();
        this.fetchReceipts(rowsPerPage);
      } else {
        this.pagination.rowsPerPage = 10;
      }
    },
    searchFilters() {
      this.pagination.page = 1;
      this.update();
    },
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true,
    },
  },
  created() {
    this.update();
  },
};
</script>